import React, {useEffect, useState} from 'react';
import ApiService from "../../../../../services/ApiService";
import moment from "moment";
import logger from "../../../../../services/logger"


const BlogSidebar = (props) => {

    const context=props.context
    const {org,config}=context

    const [dataCategorie,setDataCategorie]=useState([])
    const [recents,setRecents]=useState([])


    const getRecents=async()=>{
        var res=await ApiService.get("/auto-content/preview")
        setRecents(res.data)
    }

    const getByCategorie=async(categorie,id)=>{
        var res=await ApiService.get("/auto-content/categorie/"+categorie+"/"+id)
        logger.debug({ res }, "res")
        setDataCategorie(res.data)
    }

    useEffect(() => {
        getRecents()

        if(props.item && props.item.categorie){
            getByCategorie(props.item.categorie,props.item._id)
        }
    }, []);


    return(
        <div className="col col-lg-4 col-md-12 col-12">
            <div className="wpo-blog-sidebar">
                {dataCategorie.length>0 && (
                    <div className="widget recent-post-widget">
                        <h3>{props.item.categorieLabel}</h3>
                        {dataCategorie.map(i=>{
                            return (
                                <div className="posts" style={{marginBottom:20}}>
                                    <div className="post">
                                        <div className="img-holder">
                                            <img src={i.image} alt={i.title} style={{minHeight:50,objectFit:"cover"}}/>
                                        </div>
                                        <div className="details">
                                            <h4><a href={org.BASE_WEB_URL+"/article/"+i._id}>{i.title}</a>
                                            </h4>
                                            <span className="date">{moment(i.datetime).format("DD MMM YYYY")}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                )}
                {recents.length>0 && (
                    <div className="widget recent-post-widget">
                        <h3>Articles Récents</h3>
                        {recents.map(i=>{
                            return (
                                <div className="posts" style={{marginBottom:20}}>
                                    <div className="post">
                                        <div className="img-holder">
                                            <img src={i.image} alt={i.title} style={{minHeight:50,objectFit:"cover"}}/>
                                        </div>
                                        <div className="details">
                                            <h4><a href={org.BASE_WEB_URL+"/article/"+i._id}>{i.title}</a>
                                            </h4>
                                            <span className="date">{moment(i.datetime).format("DD MMM YYYY")}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                )}

            </div>
        </div>
    )

}

export default BlogSidebar;
